module.exports = __webpack_public_path__ + "static/media/avatar-default.0b06e83e.svg";